/**
 * Client Pocketbase singleton.
 * Utilise les variables d'environnement injectees par Vite.
 * Ne jamais importer directement dans les composants UI - passer par les services.
 */

import PocketBase from 'pocketbase';

const pbUrl = import.meta.env.VITE_POCKETBASE_URL as string | undefined;

export const pb: PocketBase | null = pbUrl ? new PocketBase(pbUrl) : null;
